import {
  IcApple24Icon,
  IcGoogle24Icon,
  IcHuawei24Icon,
  IcRuStore24Icon,
  IcSamsung24Icon,
  IcXMi24Icon,
} from '@gem/icons/apps';

import { TMobileAppName, TMobileAppItem } from './MobileAppsList.types';

export const MOBILE_APPS: Record<TMobileAppName, TMobileAppItem> = {
  ruStore: {
    url: '',
    name: 'ruStore',
    Icon: IcRuStore24Icon,
  },
  appStore: {
    url: '',
    name: 'appStore',
    Icon: IcApple24Icon,
  },
  googlePlay: {
    url: '',
    name: 'googlePlay',
    Icon: IcGoogle24Icon,
  },
  galaxyStore: {
    url: '',
    name: 'galaxyStore',
    Icon: IcSamsung24Icon,
  },
  appGallery: {
    url: '',
    name: 'appGallery',
    Icon: IcHuawei24Icon,
  },
  miAppMall: {
    url: '',
    name: 'miAppMall',
    Icon: IcXMi24Icon,
  },
};
